import { ROLES } from '../../../../../helpers/commons.helpers';

/**
 * Tools route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object with common
 * properties used by navigation guards and permission checks.
 *
 * @typedef {Object} ToolRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - When true the route requires an authenticated session.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/tools/vehicles-gallery",
        name: "VehiclesGallery",
        meta: {
            title: "Vehicles Gallery",
            modules: ["vehicles-gallery"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER,]
        },
        component: () =>
            import(
            /* webpackChunkName: "ToolsVehiclesGallery" */ "@/modules/tools/modules/vehiclesGallery/pages/VehiclesGallery"
            )
    },
    {
        path: "/tools/vehicles-gallery/new-photos",
        name: "NewUploadPhotos",
        meta: {
            title: "New Upload Photos",
            modules: ["vehicles-gallery"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER]
        },
        component: () =>
            import(
            /* webpackChunkName: "ToolNewPhotos" */ "@/modules/tools/modules/vehiclesGallery/pages/NewPhotos"
            )

    },
    {
        path: "/tools/vehicles-gallery/upload-photos/:id",
        name: "UploadPhotos",
        meta: {
            title: "Upload Photos",
            modules: ["vehicles-gallery"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER]
        },
        component: () =>
            import(
            /* webpackChunkName: "ToolsUploadPhoto" */ "@/modules/tools/modules/vehiclesGallery/pages/UploadPhotos"
            )
    }
]